import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import H2 from '../../components/Titles/h2';
import Hr from '../../components/Style/hr';
import SystempayComponent from '../../components/Paiement/systempay';
import ButtonSecondary from '../../components/Buttons/button-secondary';
import Loading from '../../components/Loading/loading';
import { useCart } from '../../contexts/cart-context';
import Systempay from '../../services/systempay.service';

export default function StepPaymentCart({ orderInfos, returnedData }) {
    const { t } = useTranslation();
    const { cart } = useCart();

    const [paymentData, setPaymentData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [errorMsg, setErrorMsg] = useState(null);

    const handlePaid = () => {
        returnedData && returnedData({ type: 'PAID' });
    };

    const handleBack = () => {
        // Retour à l’étape infos personnelles
        returnedData && returnedData('personnalInfos');
    };

    const initPayment = async () => {
        if (!orderInfos) return;
        setLoading(true);
        setErrorMsg(null);

        const payload = {
            personnalInfo: orderInfos.personnalInfo,
            billingInfo: orderInfos.billingInfo,
            cart
        };

        try {
            const response = await Systempay.createCartPayment(payload);
            const res = response.data;

            if (!res.status) {
                console.error('Erreur Systempay :', res.message || res);
                setErrorMsg(
                    t('cart.payment.error') ||
                    "Une erreur est survenue lors de l'initialisation du paiement. Merci de réessayer."
                );
                setLoading(false);
                return;
            }

            const { formToken, publicKey } = res.data || {};

            const language =
                (orderInfos.billingInfo.country &&
                    orderInfos.billingInfo.country.toLowerCase().startsWith('fr'))
                    ? 'fr'
                    : 'en';

            setPaymentData({
                formToken,
                publicKey,
                language
            });
            setLoading(false);
        } catch (error) {
            console.error("Erreur lors de l'initialisation du paiement :", error);
            setErrorMsg(
                t('cart.payment.error') ||
                "Une erreur est survenue lors de l'initialisation du paiement. Merci de réessayer."
            );
            setLoading(false);
        }
    };

    useEffect(() => {
        initPayment();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // on initialise une seule fois à l'arrivée sur cette étape

    return (
        <div className="flex flex-col lg:flex-row gap-12">
            <div className="w-full lg:w-1/3">
                <H2
                    title={t('cart.payment.title') || 'Informations de paiement'}
                    fontWeight="semibold"
                />
                <Hr />
                <p className="text-sm text-description opacity-70 mt-3">
                    {t('cart.payment.description') ||
                        'Merci de renseigner vos informations bancaires afin de régler votre commande.'}
                </p>
            </div>

            <div className="w-full lg:w-2/3">
                {loading && (
                    <div className="flex flex-col items-center justify-center gap-4 py-8">
                        <Loading />
                        <p className="text-sm text-description opacity-70">
                            {t('cart.payment.loading') ||
                                "Initialisation du paiement en cours, merci de patienter..."}
                        </p>
                    </div>
                )}

                {!loading && errorMsg && (
                    <div className="flex flex-col gap-4 py-8">
                        <p className="text-sm text-red-600">
                            {errorMsg}
                        </p>
                        <div className="flex justify-end gap-3">
                            <ButtonSecondary
                                text={t('cart.payment.retry') || 'Réessayer'}
                                onClick={initPayment}
                            />
                            <ButtonSecondary
                                text={t('cart.back') || 'Retour'}
                                onClick={handleBack}
                            />
                        </div>
                    </div>
                )}

                {!loading && !errorMsg && paymentData && (
                    <>
                        <SystempayComponent
                            formToken={paymentData.formToken}
                            publicKey={paymentData.publicKey}
                            language={paymentData.language}
                            onPaid={handlePaid}
                        />

                        <div className="mt-8 flex justify-end">
                            <ButtonSecondary
                                text={t('cart.back') || 'Retour'}
                                onClick={handleBack}
                            />
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}